import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/services';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import AuthLayout from '@/layouts/auth-layout';
import { useTranslation } from 'react-i18next';

const SignUpForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    phone_number: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    if (formData.password !== formData.confirmPassword) {
      setMessage(t('passwordsDontMatch'));
      setLoading(false);
      return;
    }
    const { error } = await supabase.auth.signUp({
      email: formData.email,
      password: formData.password,
    });
    if (error) {
      setMessage(error.message);
    } else {
      navigate('/verify', { state: { email: formData.email } });
    }
    setLoading(false);
  };

  return (
    <AuthLayout>
      <form
        onSubmit={handleSubmit}
        className="space-y-4 w-full flex flex-col items-center"
      >
        <div className="space-y-2 w-full max-w-sm">
          <Label htmlFor="email">{t('email')}</Label>
          <Input
            id="email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="space-y-2 w-full max-w-sm">
          <Label htmlFor="password">{t('password')}</Label>
          <Input
            id="password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="space-y-2 w-full max-w-sm">
          <Label htmlFor="confirmPassword">{t('confirmPassword')}</Label>
          <Input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>
        {message && <p className="text-red-500">{message}</p>}
        <div className="flex flex-col items-center justify-center w-full">
          <Button type="submit" className=" w-fit" disabled={loading}>
            {t('signUp')}
          </Button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default SignUpForm;
